



























































import '@/assets/scss/pages/app-todo.scss';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import PolicyForm from '@/forms/PolicyForm.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormMixin } from '@/mixins/FormMixin';
import TaskOverview from '@/views/pages/tasks/TaskOverview.vue';
import { BModal } from 'bootstrap-vue';
import { mixins } from 'vue-class-component';
import { ArrowLeftIcon, ArrowRightIcon, PlusIcon, XIcon } from 'vue-feather-icons';
import { Component, Prop } from 'vue-property-decorator';
import { PolicyApi } from '@/services/PolicyApi';
import { PolicyStatus } from 'admiral-core';
import { DateFilter } from 'admiral-core';
import { AuthAction } from '@/store/AuthModule';

@Component({
  components: {
    FormSubmit,
    PolicyForm,
    ArrowLeftIcon,
    ArrowRightIcon,
    PlusIcon,
    TaskOverview,
    XIcon,
  },
})
export default class TransferOpenPoliciesModal extends mixins(FormMixin, BaseMixin) {
  openPoliciesCount: number | null = null;

  lastBusinessYear: number | null = null;
  currentBusinessYear: number | null = null;
  loading = false;

  async mounted() {
    // show modal

    const currentYear = new Date().getFullYear();
    this.lastBusinessYear = currentYear - 1;
    this.currentBusinessYear = currentYear;

    if (!this.hasAchievement('transferPolicies' + currentYear) && this.isAdmin) {
      await this.loadOpenPoliciesCount();

      if (this.openPoliciesCount && this.openPoliciesCount > 0) {
        (this.$refs['ask-for-transfer'] as BModal).show();
      }
    }
  }

  async ok(evt: Event) {
    evt.preventDefault();

    try {
      this.loading = true;
      const response = await PolicyApi.transferOpenPolicies(this.agency);
      this.$toastr.s('Die Anbahnungen wurden erfolgreich übertragen.');
      const currentYear = new Date().getFullYear();
      await this.$store.dispatch(`AuthModule/${AuthAction.UpdateAchievements}`, {
        item: 'transferPolicies' + currentYear,
      });
    } catch (e) {
      this.$toastr.e(
        'Beim Übertragen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
    } finally {
      this.loading = false;
    }

    (this.$refs['ask-for-transfer'] as BModal).hide();
  }

  async cancel() {
    const currentYear = new Date().getFullYear();
    (this.$refs['ask-for-transfer'] as BModal).hide();
    await this.$store.dispatch(`AuthModule/${AuthAction.UpdateAchievements}`, {
      item: 'transferPolicies' + currentYear,
    });
  }

  reload() {
    //
  }

  async loadOpenPoliciesCount() {
    try {
      const response = await PolicyApi.getPolicies({
        agency: this.agency!,
        businessYear: new Date().getFullYear() - 1,
        status: [PolicyStatus.OPEN],
        dateFilter: DateFilter.ALL,
        products: [],
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });
      this.openPoliciesCount = response.data.length;

      console.log(response.data);
    } catch (e) {
      console.log(e);
      this.openPoliciesCount = 0;
    }
  }
}
